import { useEffect, useState } from "react";
import type { AdminContactMessage, RequestStatus } from "@tih/shared";
import { adminFetchContact, adminUpdateContact } from "../../api/client";

export function AdminContactPage() {
  const [rows, setRows] = useState<AdminContactMessage[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  async function load() {
    setLoading(true);
    setError(null);
    try {
      setRows(await adminFetchContact());
    } catch (e) {
      setError(String((e as Error).message ?? e));
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { void load(); }, []);

  async function setStatus(id: number, status: RequestStatus) {
    await adminUpdateContact(id, status);
    await load();
  }

  return (
    <div className="admin-page">
      <header className="admin-page-header">
        <h1>Messages</h1>
        <p>{rows.length} contact form submissions</p>
      </header>
      {error && <div className="form-error">{error}</div>}
      {loading ? (
        <div style={{ opacity: 0.5 }}>Loading…</div>
      ) : rows.length === 0 ? (
        <div style={{ opacity: 0.6 }}>No messages yet.</div>
      ) : (
        <ul className="admin-cards">
          {rows.map((m) => (
            <li key={m.id} className="admin-card">
              <div className="admin-card-meta">
                <strong>{m.name}</strong>
                <a href={`mailto:${m.email}`}>{m.email}</a>
                <span>· {new Date(m.createdAt).toLocaleString()}</span>
                <span className={`status-pill status-${m.status.toLowerCase()}`}>{m.status}</span>
              </div>
              {m.subject && <h3 style={{ margin: "12px 0 8px" }}>{m.subject}</h3>}
              <p style={{ whiteSpace: "pre-wrap", margin: 0 }}>{m.body}</p>
              <div className="admin-card-actions">
                <select
                  value={m.status}
                  onChange={(e) => setStatus(m.id, e.target.value as RequestStatus)}
                  className={`status-select status-${m.status.toLowerCase()}`}
                >
                  <option value="NEW">New</option>
                  <option value="IN_PROGRESS">In progress</option>
                  <option value="DONE">Done</option>
                </select>
                <a href={`mailto:${m.email}`} className="btn btn-ghost">Reply via email</a>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
